<template>
  <div>
    <h1>Proformas</h1>
    <List :items="proforms" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "ProformsPage",
  components: { List },
  data() {
    return {
      proforms: [],
      columns: [
        { key: "product", label: "Producto" },
        { key: "shipper", label: "Shipper" },
        { key: "supplier", label: "Proveedor" },
        { key: "incoterm", label: "Incoterm" },
        { key: "documentation", label: "Documentación" },
        { key: "signature", label: "Firma" },
        { key: "bankAccount", label: "Cuenta Bancaria" },
        { key: "billingAddress", label: "Dirección de Facturación" },
        { key: "catchArea", label: "Catch Area" },
      ],
    };
  },
  async mounted() {
    try {
      const response = await wencesApi.get("/api/gotrading/proforms");
      this.proforms = response.data;
    } catch (error) {
      console.error("Error al obtener proformas:", error);
    }
  },
};
</script>
